<template>
  <div class="upload-img">
    <div class="upload-list"
         v-for="(item, index) in uploadList"
         :key="index">
      <template v-if="item.status === 'finished'">
        <img :src="$publicData.ossUrl +item.url"
             @click="showViewer(index)" />
        <!-- 图片删除 删除图标-->
        <!-- <div class="upload-list-cover">
            <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
          </div>-->
        <!-- 改 删除图标 -->
        <div class="upload-list-cover">
          <Icon type="ios-close"
                @click.native="handleRemove(item,index)"></Icon>
        </div>
      </template>
      <template v-else>
        <Progress v-if="item.showProgress"
                  :percent="item.percentage"
                  hide-info></Progress>
      </template>
    </div>
    <!-- 上传，限制张数 -->
    <Upload ref="upload-thumb"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['jpg', 'jpeg', 'png', 'gif']"
            :max-size="7168"
            :on-format-error="handleFormatError"
            :on-exceeded-size="handleMaxSize"
            :before-upload="handleBeforeUpload"
            :multiple="multipleStatus"
            type="drag"
            name="imgFile"
            :data="postData"
            action="/common/upload/file"
            :style="{
          display: uploadList.length >= maxNum ? 'none' : 'inline-block',
          width: '58px',
        }">
      <div style="width: 58px; height: 58px; line-height: 58px">
        <Icon type="ios-camera"
              size="20"></Icon>
      </div>
    </Upload>
    <!-- <Alert>上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，请自己处理好宽高比例</Alert> -->
    <Alert v-if="defaultTip != ''">{{ defaultTip }}</Alert>
    <!-- 图片预览 -->
    <viewer :options="viewerOptions"
            :images="uploadList"
            @inited="inited"
            class="viewer"
            ref="viewer">
      <template>
        <figure class="images">
          <div class="image-wrapper"
               v-for="img in uploadList"
               :key="$publicData.ossUrl +img.url">
            <img class="image"
                 :src="$publicData.ossUrl+img.url"
                 :data-source="$publicData.ossUrl+img.url"
                 :alt="img.url" />
          </div>
        </figure>
      </template>
    </viewer>
  </div>
</template>
  
  <script>
export default {
  name: "UploadThumb",
  data () {
    return {
      // 已经上传成功的所有文件结果
      uploadList: [],
      postData: {
        thumb: 0,
        thumbWidth: "200px",
        thumbWidth: "200px"
      },
      tipInfo:
        "上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，请自己处理好宽高比例",
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      }
    };
  },
  props: {
    defaultList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    defaultTip: {
      type: String,
      default: function () {
        return this.tipInfo;
      }
    },
    multipleStatus: {
      type: Boolean,
      default: function () {
        return true;
      }
    },
    maxNum: {
      type: Number,
      default: function () {
        // return 10;
        return 20;
      }
    }
  },
  mounted () {
    this.uploadList = this.$refs["upload-thumb"].fileList;
    // console.log("11111", this.$viewer);
  },
  watch: {
    defaultList (curVal, oldVal) {
      if (curVal) {
        this.uploadList = curVal;
        // for (let i = 0; i < this.uploadList.length; i++) {
        //   var thumbs = this.uploadList[i].url;
        //   if (thumbs.indexOf('http') == "-1") {
        //     this.uploadList[i].url = this.$publicData.ossUrl + this.uploadList[i].url;
        //   } else {
        //     this.uploadList[i].url = this.uploadList[i].url;
        //   }
        //   // this.uploadList = this.uploadList[i];
        // }
        // console.log('this.uploadList', this.uploadList)
      }
    },
    defaultTip (curVal, oldVal) {
      if (curVal) {
        this.tipInfo = curVal;
      }
    },
    multiple (curVal, oldVal) {
      if (curVal) {
        // console.log("multiple:", curVal);
        this.multipleStatus = curVal;
      }
    },
    maxFileNum (curVal, oldVal) {
      if (curVal) {
        console.log("maxFileNum:", curVal);
        this.maxNum = curVal;
      }
    }
  },
  created: function () {
    // console.log("111");
  },
  methods: {
    handleClearFiles () {
      // 再次点击上传之前，清空之前已上传文件
      this.$refs["upload-thumb"].clearFiles();
    },
    // 移除的回调
    handleRemove (file, index) {
      this.$refs["upload-thumb"].fileList.splice(index, 1);
      this.defaultList.splice(index, 1);
    },
    // 上传成功的回调
    handleSuccess (res, file) {
      if (res.code == 200) {
        file.name = res.result.filename;
        file.url = res.result.url;
        // 更新显示的
        this.uploadList = this.$refs["upload-thumb"].fileList;
        // for (let i = 0; i < this.uploadList.length; i++) {
        //   var thumbs = this.uploadList[i].url;
        //   this.$refs["upload-thumb"].fileList = thumbs;
        //   if (thumbs.indexOf('http') == "-1") {
        //     this.uploadList[i].url = this.$publicData.ossUrl + this.uploadList[i].url;
        //   } else {
        //     this.uploadList[i].url = this.uploadList[i].url;
        //   }
        // }
        // console.log(this.$refs["upload-thumb"].fileList);
      } else {
        this.$Notice.warning({
          title: "上传失败",
          desc: "请检查网络及上传的内容是否符合要求！"
        });
      }
    },
    // 检查文件格式
    handleFormatError (file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "文件 " + file.name + " 格式不正确, 请插入jpg/jpeg/png/gif图片。"
      });
    },
    // 检查大小
    handleMaxSize (file) {
      this.$Notice.warning({
        title: "文件大小超出限制",
        desc: "文件 " + file.name + " 太大，最大就不要超过2M！"
      });
    },
    // 上传前检查数量
    handleBeforeUpload () {
      const check = this.uploadList.length < this.maxNum;
      if (!check) {
        this.$Notice.warning({
          title: "已经超出最大可上传数量！"
        });
      }
      return check;
    },
    // 初始化viewer
    inited (viewer) {
      // console.log("viewer", viewer);
      this.$viewer = viewer;
    },
    // 预览图片
    showViewer (index) {
      // console.log("index", index);
      this.$viewer.view(index);
    }
  }
};
  </script>
  
  
  <style scoped>
.upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.upload-list img {
  width: 100%;
  height: 100%;
}
.upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  /* bottom: 0;
    left: 0; */
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
}
.upload-list:hover .upload-list-cover {
  display: block;
}
.upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.ivu-icon-ios-close:before {
  position: absolute;
  top: 0;
  right: 0;
}
/* 图片预览 */
.image {
  display: none;
}
.viewer-loading > img {
  display: none; /* hide big images when it is loading */
}
</style>
  